import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-registeruseras',
  templateUrl: './registeruseras.component.html',
  styleUrl: './registeruseras.component.css'
})
export class RegisteruserasComponent {

  constructor(private router: Router) { }

  gotoMSMERegistration() {
    sessionStorage.setItem('registerUserAsCompleted', 'true');
    this.router.navigate(['/register']);
  }

  gotoIARegistration() {
    sessionStorage.setItem('registerUserAsCompleted', 'true');
    this.router.navigate(['/iaregister']);
  }
}
